import { render } from "./doctor-changepassword.vue?vue&type=template&id=6ce77198&scoped=true"
import script from "./doctor-changepassword.vue?vue&type=script&lang=js"
export * from "./doctor-changepassword.vue?vue&type=script&lang=js"

import "./doctor-changepassword.vue?vue&type=style&index=0&id=6ce77198&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce77198"]])

export default __exports__